import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import {reduxForm, SubmissionError} from 'redux-form'
import {connect} from 'react-redux'

import {getOrNull} from '../../libs/utils'
import config from '../../config'
import {
    startGuestyOnboard,
    startRentalsUnitedOnboard,
    startHostAwayOnboard,
    startCloudbedsOnboard,
    startMyvrOnboard,
    startBeds24Onboard,
    startBookingOnboard,
    startSmartbnbOnboard,
    startHostfullyOnboard,
    startImpalaOnboard,
    startOperaOnboard,
    startStreamlineOnboard,
    startInforhmsOnboard,
    startLavandaOnboard,
    startTrackOnboard,
    startStayntouchOnboard,
    startApaleoOnboard,
    startEscapiaOnboard,
    checkTaskStatus,
    updateAfterIntegration,
    updateOauthConnection,
    getSignupContextFromToken,
} from '../../reducers/onboard'
import {setAuth, loadAuth} from '../../reducers/auth'
import {createCookie} from '../../libs/cookies'

import Container from '@material-ui/core/Container'
import ErrorBox from '../ErrorBox/ErrorBox'
import getScreen from './screens'


const TaskTypes = [
    'ONBOARD_GUESTY_USER',
    'ONBOARD_RENTALSUNITED_USER',
    'ONBOARD_HOSTAWAY_USER',
    'ONBOARD_CLOUDBEDS_USER',
    'ONBOARD_MYVR_USER',
    'ONBOARD_BEDS24_USER',
    'ONBOARD_BOOKING_USER',
    'ONBOARD_SMARTBNB_USER',
    'ONBOARD_INFORHMS_USER',
    'ONBOARD_HOSTFULLY_USER',
    'ONBOARD_IMPALA_USER',
    'ONBOARD_OPERA_USER',
    'ONBOARD_STREAMLINE_USER',
    'ONBOARD_LAVANDA_USER',
    'ONBOARD_TRACKHS_USER',
    'ONBOARD_STAYNTOUCH_USER',
    'ONBOARD_APALEO_USER',
    'ONBOARD_ESCAPIA_USER',
]

class GuestyIntegrationWizard extends Component {

    state = {
        auth: {},
        page: 1,
        error: null,
        connectGuesty: 'marketplace',
        _timer: null,
        ctx: {},
    }

    componentWillReceiveProps = (nextProps) => {
        // start polling task status
        if (nextProps.task.status && nextProps.task.status === "PENDING" && TaskTypes.includes(nextProps.task.type) && !this.props.task.status) {
            this.setState({_timer: setInterval(this.checkTaskStatus, 3500)})
        }
        // stop polling task status and move to next page
        if (this.state._timer && nextProps.task.status && nextProps.task.status !== "PENDING" && TaskTypes.includes(nextProps.task.type)) {
            clearInterval(this.state._timer)
            // if (nextProps.task.status === "FINISHED") {
            //     this.nextPage()
            // }
        }

        // when we get basic user info from PMS API (after sync task with PMS finished)
        if (nextProps.task.data && nextProps.task.data.email && !this.props.task.data) {

            // set risk and email fields with values once sync has finished
            this.props.autofill('email', nextProps.task.data.email)
            this.props.autofill('risk', 'balanced')

            // track with Segment when PMS sync finished
            this.sendSegment('track', {
                name: 'Completed Sync with PMS',
                data: {
                    pms: this.props.pms,
                }
            })

            // send first `identify` event to Segment
            this.sendSegment('identify', {
                user: {
                    id: nextProps.task.data.autohost_user_id,
                    email: nextProps.task.data.email,
                    name: nextProps.task.data.name,
                }
            })
        }
    }

    componentDidMount() {
        const {pms, user, router, autofill, change, getSignupContextFromToken} = this.props
        const query = router.query || {}

        // catch OAuth codes on redirect for MyVR integration
        if (query.code) {
            autofill('code', query.code)
            this.nextPage()
        }
        if (query.error) {
            this.setState({error: query.error})
            this.nextPage()
        }

        // save signup context key to local storage in case of refresh or OAuth redirect
        if (query.ctx) {
            localStorage.setItem('ctx', query.ctx);
        }

        // load signup context key from local storage
        if (!query.ctx) {
            query.ctx = localStorage.getItem('ctx');
        }

        // parse ctx param used for channel/partner account signups
        if (query.ctx) {
            try {
                (async () => {
                    query.ctx = await getSignupContextFromToken(query.ctx);
                    this.setState({ctx: query.ctx});
                    change('pa', query.ctx.xd);
                })();
            } catch (e) {
                localStorage.removeItem('ctx');
                console.error(e);
            }
        }

        // if user is logged in, autofill connection form with user data
        if (user) {
            autofill('api_key', getOrNull(`${pms}.api_key`, user));
            autofill('api_secret', getOrNull(`${pms}.api_secret`, user));
            autofill('properties', getOrNull(`${pms}.hotels`, user));
        }
    }

    nextPage = () => {
        this.setState({
            page: this.state.page + 1
        })
    }

    prevPage = () => {
        this.setState({
            page: this.state.page - 1
        })
    }

    checkTaskStatus = () => {
        const {task, checkTaskStatus} = this.props
        if (task) {
            checkTaskStatus(task);
        }
    }

    handleSwapGuestyScreen = (event) => {
        event.preventDefault()
        const {connectGuesty} = this.state
        const screen = connectGuesty === 'marketplace' ? 'api' : 'marketplace'
        this.setState({connectGuesty: screen})
    }

    handleConfirmedEmail = () => {
        // track with segment.io
        this.sendSegment('track', {
            name: 'Confirmed Email',
            data: {
                pms: this.props.pms,
            }
        })
        this.nextPage()
    }

    handleSelectedRiskTolerance = () => {
        // track with segment.io
        this.sendSegment('track', {
            name: 'Selected Risk Tolerance',
            data: {
                pms: this.props.pms,
            }
        })
        this.nextPage()
    }

    handleSelectedSoftware = () => {
        // track with segment.io
        this.sendSegment('track', {
            name: 'Selected Integration',
            data: {
                pms: this.props.pms,
            }
        })
        this.nextPage()
    }

    handleUpdateConnection = async form => {
        const {pms, updateOauthConnection, onSubmit, loadAuth} = this.props;

        // log event
        this.sendSegment('track', {
            name: 'Updating PMS Connection',
            data: {
                pms: pms
            }
        })

        // create task to do async magic
        try {
            await updateOauthConnection(form, pms)
        } catch (e) {
            throw new SubmissionError({_error: e})
        }

        // update user state
        loadAuth();

        // finish by calling the `onSubmit` callback
        onSubmit();
    }

    handleStartOnboarding = async (form) => {
        // step one syncs with selected PMS and pulls basic user details


        const {
            pms,
            startGuestyOnboard,
            startRentalsUnitedOnboard,
            startHostAwayOnboard,
            startBeds24Onboard,
            startCloudbedsOnboard,
            startMyvrOnboard,
            startBookingOnboard,
            startSmartbnbOnboard,
            startHostfullyOnboard,
            startInforhmsOnboard,
            startImpalaOnboard,
            startOperaOnboard,
            startStreamlineOnboard,
            startLavandaOnboard,
            startTrackOnboard,
            startStayntouchOnboard,
            startApaleoOnboard,
            startEscapiaOnboard,
        } = this.props

        // map `pms` value to correct function
        const pmsFunc = {
            'guesty': startGuestyOnboard,
            'rentalsunited': startRentalsUnitedOnboard,
            'hostaway': startHostAwayOnboard,
            'beds24': startBeds24Onboard,
            'cloudbeds': startCloudbedsOnboard,
            'myvr': startMyvrOnboard,
            'booking': startBookingOnboard,
            'smartbnb': startSmartbnbOnboard,
            'inforhms': startInforhmsOnboard,
            'hostfully': startHostfullyOnboard,
            'impala': startImpalaOnboard,
            'opera': startOperaOnboard,
            'streamline': startStreamlineOnboard,
            'lavanda': startLavandaOnboard,
            'trackhs': startTrackOnboard,
            'stayntouch': startStayntouchOnboard,
            'apaleo': startApaleoOnboard,
            'escapia': startEscapiaOnboard,
        }

        // move to next screen
        this.nextPage();

        // track with segment.io
        this.sendSegment('track', {
            name: 'Added Integration API Keys',
            data: {
                pms: pms
            }
        })

        // create task to do async magic
        try {
            await pmsFunc[pms](form)
        } catch (e) {
            throw new SubmissionError({_error: e})
        }
    }

    handleSaveUser = async (form) => {
        // update user details and authenticate them


        const {pms, task, updateAfterIntegration, setAuth} = this.props

        // update user
        let user
        try {
            user = await updateAfterIntegration(form, task)
        } catch (e) {
            throw new SubmissionError({_error: e})
        }

        // update user state
        this.setState({
            auth: {
                user,
                session: user.sessionId,
                authenticated: true,
                loaded: true
            }
        })

        // track with segment.io
        this.sendSegment('track', {
            name: 'Finished On-boarding',
            data: {
                pms: pms
            }
        })

        // send second `identify` event to Segment
        this.sendSegment('identify', {user: user})

        // create cookie for user
        createCookie(config.cookieName, user.sessionId)

        // move to next screen
        this.nextPage();
    }

    handleFinishOnboarding = (user) => {
        const {pms, onSubmit, loadAuth} = this.props;
        const redirect = getOrNull('ctx.redirect', this.state);

        // track event
        this.sendSegment('track', {
            name: 'User Signup Complete',
            data: {
                pms: pms
            }
        });

        if (redirect && redirect.startsWith('https://')) {
            window.location = redirect;
        }

        if (!redirect) {
            // update user state
            loadAuth();

            // finish by calling the `onSubmit` callback
            onSubmit(user);
        }
    }

    sendSegment = (event, options, cb) => {
        const segment = this.props.segment || window && window.analytics
        if (segment) {
            if (config.env !== 'production') {
                segment.debug()
            }
            if (event === 'identify') {
                segment.identify(options.user.id, {
                    name: options.user.name,
                    email: options.user.email,
                }, cb)
            }
            if (event === 'track') {
                segment.track(options.name, {
                    ...options.data
                }, cb)
            }
        } else {
            if (cb) {
                cb()
            }
        }
    }

    render() {
        const {error, task, pms, router} = this.props;
        const {auth, page, connectGuesty, ctx} = this.state;
        const stateError = this.state.error;
        const user = auth.user;

        // get current screen
        const screen = getScreen({
            page: page - 1,
            pms,
            guesty: connectGuesty,
            ctx: ctx,
            update: Boolean(
                getOrNull('myvr.account_id', this.props.user || {}) ||
                getOrNull('booking.account_id', this.props.user || {}) ||
                getOrNull('cloudbeds.account_id', this.props.user || {}) ||
                getOrNull('apaleo.account_id', this.props.user || {}) ||
                getOrNull('inforhms.account_id', this.props.user || {}) ||
                getOrNull('beds24.account_id', this.props.user || {}) ||
                getOrNull('guesty.account_id', this.props.user || {}) ||
                getOrNull('hostfully.account_id', this.props.user || {})
            ),
        })
        const {CurrentScreen, screenName} = screen;

        if (!CurrentScreen) {
            return null
        }

        // props for screen
        const defaultProps = {
            pms,
            user,
            router,
            onSubmit: this.nextPage
        }

        // add required props as defined in `propsKeys` object
        if (screen.propsKeys[screenName]) {
            Object.keys(screen.propsKeys[screenName]).forEach(key => {
                defaultProps[key] = this[screen.propsKeys[screenName][key]]
            })
        }

        return (
            <Container maxWidth="md">

                {(error || task.error || stateError) &&
                <Fragment>
                    <ErrorBox error={error || task.error || stateError}/>
                </Fragment>
                }

                <CurrentScreen {...defaultProps}/>
            </Container>
        )
    }
}

GuestyIntegrationWizard.propTypes = {
    // component
    onSubmit: PropTypes.func.isRequired,
    pms: PropTypes.string.isRequired,
    router: PropTypes.object.isRequired,
    user: PropTypes.object,

    // connected
    startGuestyOnboard: PropTypes.func.isRequired,
    startRentalsUnitedOnboard: PropTypes.func.isRequired,
    startHostAwayOnboard: PropTypes.func.isRequired,
    startCloudbedsOnboard: PropTypes.func.isRequired,
    startMyvrOnboard: PropTypes.func.isRequired,
    startBeds24Onboard: PropTypes.func.isRequired,
    startBookingOnboard: PropTypes.func.isRequired,
    startSmartbnbOnboard: PropTypes.func.isRequired,
    startHostfullyOnboard: PropTypes.func.isRequired,
    startImpalaOnboard: PropTypes.func.isRequired,
    startOperaOnboard: PropTypes.func.isRequired,
    startStreamlineOnboard: PropTypes.func.isRequired,
    startInforhmsOnboard: PropTypes.func.isRequired,
    startLavandaOnboard: PropTypes.func.isRequired,
    startTrackOnboard: PropTypes.func.isRequired,
    startStayntouchOnboard: PropTypes.func.isRequired,
    startApaleoOnboard: PropTypes.func.isRequired,
    startEscapiaOnboard: PropTypes.func.isRequired,
    checkTaskStatus: PropTypes.func.isRequired,
    updateAfterIntegration: PropTypes.func.isRequired,
    updateOauthConnection: PropTypes.func.isRequired,
    getSignupContextFromToken: PropTypes.func.isRequired,
    loadAuth: PropTypes.func.isRequired,
    setAuth: PropTypes.func.isRequired,
    task: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    loaded: PropTypes.bool,

    // redux-form
    error: PropTypes.any,
    autofill: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
    return {
        loading: state.onboard.loading,
        loaded: state.onboard.loaded,
        task: state.onboard.task,
    }
}

const ReduxForm = {
    form: 'wizard', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount,
}

export {GuestyIntegrationWizard}
export default compose(
    reduxForm(ReduxForm),
    connect(mapStateToProps, {
        startGuestyOnboard,
        startRentalsUnitedOnboard,
        startHostAwayOnboard,
        startCloudbedsOnboard,
        startMyvrOnboard,
        startBeds24Onboard,
        startBookingOnboard,
        startSmartbnbOnboard,
        startHostfullyOnboard,
        startImpalaOnboard,
        startOperaOnboard,
        startStreamlineOnboard,
        startInforhmsOnboard,
        startLavandaOnboard,
        startTrackOnboard,
        startStayntouchOnboard,
        startApaleoOnboard,
        startEscapiaOnboard,
        checkTaskStatus,
        updateAfterIntegration,
        updateOauthConnection,
        getSignupContextFromToken,
        loadAuth,
        setAuth,
    }),
)(GuestyIntegrationWizard)
